import {
  Box,
  Card,
  Stack,
  Tooltip,
  TooltipProps,
  tooltipClasses,
  useMediaQuery,
} from '@mui/material';
import axios from 'axios';
import moment from 'moment';

import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { styled } from '@mui/material/styles';
import SimpleSnackbar from 'src/pages/details-page/sub-components/snackBar';
import { paths, permissions } from 'src/paths';
import {
  copyTherapyWeekActionRest,
  get7DayLookBack,
  getTherapyPlanningData_2_0,
  getTherapyPlanningLoading,
  getTherapyPlanningRangeAction,
  getTherapyPlanningSummary_2_0,
  resetApplySelectedTherapyTemplate,
  resetDeleteMdsAssessmentByDate,
  resetSingleCellReducer,
  resetTherapyPlanningDischargeDate,
  resetTherapyTemplatesAction,
} from 'src/redux/actions/therapyPlanning';
import { useTherapyPlanning } from './therapyPlanningProvider';
import UncoveredDay from './uncoveredDay_2.0';
import TherapyCard_2_0 from './TherapyCard_2_0';
import SummaryCard_2_0 from './SummaryCard_2.0';
import { useLocation, useNavigate } from 'react-router';
const { therapyPlanning } = paths;


const { UPDATE_THERAPIST_PLANNING } = permissions;

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '55%',
  borderRadius: '8px',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'white',
    color: 'black',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: ' rgba(0, 0, 0, 0.24) 0px 3px 8px',
    fontSize: 12,
  },
}));

const uncoveredDumpyData = Array.from({ length: 9 }).map((res) => {
  return {
    isUncoveredDay: false,
  };
});

const WeekView_2_0 = () => {
  const { weekStartDate, setWeekStartDate, setWeekEndDate, weekEndDate } = useTherapyPlanning();
  const dispatch = useDispatch();
  const location = useLocation()
  const navigate = useNavigate()
  const therapyPlanningAbort: any = axios.CancelToken.source();

  const [uncoveredDay, setUncoveredDay] = useState(uncoveredDumpyData);

  const [currentsDayList, setCurrentDayList] = useState<any>([]);
  const isTabletScreen = useMediaQuery((theme: any) => theme.breakpoints.down('xl'));
  const macbookScreen = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
  const [message, setMessage] = useState('');
  const updateTherapyPlanningResponse = useSelector(
    (state: any) => state?.updateTherapyPlanningReducer
  );
  const updateTherapyPlanningResponseDischargeDate = useSelector(
    (state: any) => state?.updateTherapyPlanningDischargeDateReducer
  );

  const therapyPlanning_2_0 = useSelector((state: any) => state.getTherapyPlanningDataReducer_2_0);
  const therapyPlanningSummary = useSelector(
    (state: any) => state.getTherapyPlanningSummaryReducer_2_0
  );
  const getDischargeDatesOfTherapyPlanning2_0 = useSelector(
    (state: any) => state.getTherapyPlanningDischargeDateReducer_2_0?.response?.data
  );
  const dateOfServiceResponse = useSelector(
    (state: any) => state?.getDateOfServiceReducer?.response?.data
  );

  const [currentsDayDataList, setCurrentDayDataList] = useState<any>([]);
  const providerId = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.providerId
  );
  const assessmentDetails = useSelector(
    (state: any) => state?.getAssessmentReducer?.response?.data
  );
  const getMultipleMdsAssessment = useSelector(
    (state: any) => state.getMultipleMDSAssessment?.response
  );

  const [multipleMdsAssessmentDates, setMultipleMdsAssessmentDates] = useState<any>([]);
  const assessmentDate = assessmentDetails?.assessmentDate
    ? assessmentDetails?.assessmentDate?.split('T')?.at(0)
    : '';
  const selectedPatient = useSelector((state: any) => state?.selectPatientReducer?.patientInfo);
  const getMdsAssessmentRange = useSelector((state: any) => state.getMdsAssessmentRangeReducer?.response?.data?.assessmentsByDate)
  const getTherapyPlanningLookBack = useSelector((state: any) => state.getTherapyPlanning7dayLookBack)
  // useEffect(() => {
  //   if (selectedPatient)
  //     dispatch(
  //       getAssessment({
  //         patientId: selectedPatient?.uuid,
  //       })
  //     );
  // }, [selectedPatient]);

  const constGetMdsAssessMentDate = (multipleMds: any) => {
    return multipleMds?.map((mds: any) => {
      const date = mds?.isFinalMds ? mds?.finalMds?.assessmentDate : mds?.assessmentDate;
      return !!date ? date?.split('T')?.at(0) : '';
    });
  };

  useMemo(() => {
    if (getMultipleMdsAssessment?.data?.length) {
      const getOpenEoc = getMultipleMdsAssessment?.data?.filter(
        (mds: any) => mds?.status === 'OPENED'
      );
      setMultipleMdsAssessmentDates(
        getOpenEoc?.length && !!getOpenEoc[0]?.mdsAssessments
          ? constGetMdsAssessMentDate(getOpenEoc[0]?.mdsAssessments)
          : []
      );
    }
  }, [getMultipleMdsAssessment]);

  const getPerWeekNavigationAPI = () => {
    dispatch(
      getTherapyPlanningData_2_0({
        patientId: selectedPatient?.uuid,
        abortToken: therapyPlanningAbort.token,
        source: 'GET_WEEKLY',
        params: {
          providerId,
          startDate: weekStartDate.format('YYYY-MM-DD'),
          endDate: weekStartDate.clone().add(8, 'days').format('YYYY-MM-DD'),
        },
      })
    );

    dispatch(
      getTherapyPlanningSummary_2_0({
        patientId: selectedPatient?.uuid,
        abortToken: therapyPlanningAbort.token,
        source: 'GET_WEEKLY',
        params: {
          providerId,
          startDate: weekStartDate.format('YYYY-MM-DD'),
          endDate: weekStartDate.clone().add(8, 'days').format('YYYY-MM-DD'),
        },
      })
    );
    dispatch(getTherapyPlanningRangeAction({
      patientId: selectedPatient?.uuid,
      params: {
        startDate: weekStartDate.format('YYYY-MM-DD'),
        endDate: weekStartDate.clone().add(8, 'days').format('YYYY-MM-DD'),
      },
    }))
    dispatch(get7DayLookBack({
      patientId: selectedPatient?.uuid,
      abortToken: therapyPlanningAbort.token,
      source: 'GET_WEEKLY',
      params: {
        providerId,
        today: moment().format('YYYY-MM-DD'),
        startDate: weekStartDate.format('YYYY-MM-DD'),
        endDate: weekStartDate.clone().add(8, 'days').format('YYYY-MM-DD'),
      },

    }))
  };

  useEffect(() => {
    if (location.state?.from_mds === 'ARD_Tab') {
      getPerWeekNavigationAPI();
      return
    } 
    if (selectedPatient) {
      getPerWeekNavigationAPI();
    }

    return () => {
      therapyPlanningAbort.cancel('abort api');
      dispatch(getTherapyPlanningLoading());
    };
  }, [weekStartDate, selectedPatient]);

  const [therapyPlaningNewResp, setTherapyPlaningNewResp] = useState<any>([]);
  const editSingleCellResponse = useSelector(
    (state: any) => state.editSingleCellOfTherapyPlanningReducer
  );

  useEffect(() => {
    if (!therapyPlanning_2_0?.isTherapyPlanning && !therapyPlanning_2_0?.response === null) return;

    if (!therapyPlanning_2_0?.isTherapyPlanning && !therapyPlanning_2_0?.response !== null) return;
    setTherapyPlaningNewResp(therapyPlanning_2_0?.therapyPlaningFormattedData);
  }, [therapyPlanning_2_0]);

  const copyPasteTherapyPlanner = useSelector(
    (state: any) => state.copyPasteTherapyPlanningReducer_2_0
  );

  useEffect(() => {
    if (!copyPasteTherapyPlanner?.isCopyPaste && !copyPasteTherapyPlanner?.response === null)
      return;
    if (!copyPasteTherapyPlanner.isCopyPaste && !copyPasteTherapyPlanner.response !== null) {
      dispatch(copyTherapyWeekActionRest());
      return;
    }
    if (copyPasteTherapyPlanner.isCopyPaste) {
      setMessage(copyPasteTherapyPlanner.response);
      setIsSnackBarOpen(true);
      getPerWeekNavigationAPI();
      setTimeout(() => {
        setIsSnackBarOpen(false);
        dispatch(copyTherapyWeekActionRest());
        setMessage('');
      }, 3000);

      return;
    }
  }, [copyPasteTherapyPlanner]);

  useEffect(() => {
    if (!editSingleCellResponse?.isCellEdited && !editSingleCellResponse?.response === null) return;
    if (!editSingleCellResponse?.isCellEdited && !editSingleCellResponse?.response !== null) return;
    setTimeout(() => {
      dispatch(resetSingleCellReducer());
    }, 800);
  }, [editSingleCellResponse]);

  const [isWarning, setIsWarning] = useState(false);
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);

  useEffect(() => {
    if (location.state?.from_mds === 'ARD_Tab') return
    if (
      weekStartDate.format('YYYY-MM-DD') !== moment().clone().startOf('week').format('YYYY-MM-DD')
    ) {
      setWeekStartDate(moment().clone().startOf('week'));
      setWeekEndDate(moment().clone().endOf('week'));
    }
  }, [selectedPatient]);

  useEffect(() => {
    if (
      updateTherapyPlanningResponseDischargeDate?.isTherapyPlanningUpdated === false &&
      updateTherapyPlanningResponseDischargeDate?.response === null
    )
      return;
    if (
      updateTherapyPlanningResponseDischargeDate?.isTherapyPlanningUpdated === false &&
      updateTherapyPlanningResponseDischargeDate !== null
    ) {
      setMessage(updateTherapyPlanningResponseDischargeDate?.response?.message);
      setIsSnackBarOpen(true);
      setTimeout(() => {
        setIsSnackBarOpen(false);
        dispatch(resetTherapyPlanningDischargeDate());
        setMessage('');
      }, 3000);
      return;
    } else {
      getPerWeekNavigationAPI();
      setMessage(updateTherapyPlanningResponseDischargeDate?.response?.message);
      setIsSnackBarOpen(true);
      setTimeout(() => {
        setMessage('');
        setIsSnackBarOpen(false);
        dispatch(resetTherapyPlanningDischargeDate());
      }, 3000);
    }
  }, [updateTherapyPlanningResponseDischargeDate]);

  const applyTheTherapyTemplate = useSelector(
    (state: any) => state.applyTheTherapyTemplatesReducer
  );

  useEffect(() => {
    if (!applyTheTherapyTemplate?.isTemplateUpdated && applyTheTherapyTemplate?.response === null)
      return;
    if (!applyTheTherapyTemplate?.isTemplateUpdated && applyTheTherapyTemplate !== null) {
      setMessage('Error while saving the templates');
      setIsSnackBarOpen(true);
      setIsWarning(true);
      setTimeout(() => {
        setIsSnackBarOpen(false);
        setIsWarning(false);
        dispatch(resetTherapyTemplatesAction());
        setMessage('');
      }, 3000);
      return;
    }

    setMessage('The Template has been successfully applied');
    setIsSnackBarOpen(true);
    getPerWeekNavigationAPI();
    setTimeout(() => {
      setMessage('');
      setIsSnackBarOpen(false);
      dispatch(resetTherapyTemplatesAction());
    }, 3000);
  }, [applyTheTherapyTemplate]);

  const deleteMdsAssessmentDate = useSelector((state: any) => state.deleteMdsAssessmentByDateReducer)

  useEffect(() => {
    if (
      deleteMdsAssessmentDate?.isMdsAssessmentDeleted === false &&
      deleteMdsAssessmentDate?.response === null
    )
      return;
    if (
      deleteMdsAssessmentDate?.isMdsAssessmentDeleted === false &&
      deleteMdsAssessmentDate !== null
    ) {
      setMessage(deleteMdsAssessmentDate?.response?.message);
      setIsSnackBarOpen(true);
      setTimeout(() => {
        setIsSnackBarOpen(false);
        dispatch(resetDeleteMdsAssessmentByDate());
        setMessage('');
      }, 3000);
      return;
    } else {
      // getPerWeekNavigationAPI();
      setMessage(deleteMdsAssessmentDate?.response?.message);
      setIsSnackBarOpen(true);
      setTimeout(() => {
        setMessage('');
        setIsSnackBarOpen(false);
        dispatch(resetDeleteMdsAssessmentByDate());
      }, 3000);
    }
  }, [deleteMdsAssessmentDate]);

  const applySelectedTherapyTem = useSelector(
    (state: any) => state.applySelectedTherapyPlanningTemplateReducer
  );

  useEffect(() => {
    if (!applySelectedTherapyTem?.isTemplateApply && applySelectedTherapyTem?.response === null)
      return;
    if (!applySelectedTherapyTem?.isTemplateApply && applySelectedTherapyTem !== null) {
      setMessage('Error while saving the templates');
      setIsSnackBarOpen(true);
      setIsWarning(true);
      setTimeout(() => {
        setIsSnackBarOpen(false);
        setIsWarning(false);
        dispatch(resetApplySelectedTherapyTemplate());
        setMessage('');
      }, 3000);
      return;
    }

    setMessage('The Template has been successfully applied');
    setIsSnackBarOpen(true);
    getPerWeekNavigationAPI();
    setTimeout(() => {
      setMessage('');
      setIsSnackBarOpen(false);
      dispatch(resetApplySelectedTherapyTemplate());
    }, 3000);
  }, [applySelectedTherapyTem]);

  const getCurrentWeekDatesList = () => {
    const dates = [];

    let currentDate = weekStartDate.clone();
    let weekEndDateClone = weekStartDate.clone().add(8, 'days');
    while (currentDate.isSameOrBefore(weekEndDateClone, 'day')) {
      const formattedDate = currentDate.format('YYYY-MM-DD');
      dates.push(formattedDate);
      currentDate.add(1, 'day');
    }

    return dates;
  };

  const getCurrentWeekDates = () => {
    const dates = [];

    let currentDate = weekStartDate.clone();
    let weekEndDateClone = weekStartDate.clone().add(8, 'days');

    while (currentDate.isSameOrBefore(weekEndDateClone, 'day')) {
      const formattedDate = `${currentDate.format('ddd')} ${currentDate.format('M/DD')}`;
      const dateFormat = `${currentDate.format('YYYY-MM-DD')}`;
      dates.push({
        monthFormat: formattedDate,
        dateFormat: dateFormat,
      });
      currentDate.add(1, 'day');
    }

    return dates;
  };
  useEffect(() => {
    const list = getCurrentWeekDates();
    const list1 = getCurrentWeekDatesList();
    setCurrentDayList(list);
    setCurrentDayDataList(list1);
  }, [weekStartDate]);

  useEffect(() => {
    if (
      therapyPlanning_2_0?.totalTimeSummary &&
      therapyPlanning_2_0?.totalTimeSummary?.length === 9
    ) {
      const cloneUncoveredDaysResponse = Array.from(therapyPlanning_2_0?.totalTimeSummary);
      setUncoveredDay(
        cloneUncoveredDaysResponse
          ?.sort((a: any, b: any) => {
            const date1: any = new Date(a?.date);
            const date2: any = new Date(b?.date);
            return date1 - date2;
          })
          ?.map((list: any) => {
            return {
              isUncoveredDay: list?.uncovered || false,
            };
          })
      );
    } else {
      setUncoveredDay(uncoveredDumpyData);
    }
  }, [therapyPlanning_2_0]);

  const getSingleMds = useSelector((state: any) => state.getSingleMdsAssessmentReducer)
  const [mdsNavigateDate, setNavigateDate] = useState('')

  useEffect(() => {
    if (!getSingleMds?.getMdsAssessment && !getSingleMds?.response === null) return;
    if (!getSingleMds?.getMdsAssessment && !getSingleMds?.response !== null) return;
    if (getSingleMds?.getMdsAssessment) {
      navigate(
        `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editDetails}`,
        {
          state: {
            action:'Edit',
            selectedPatient: selectedPatient,
            from: 'ARD_Tab',
            ARD_Date: mdsNavigateDate,
            assessmentDetails: getSingleMds?.response?.data
          },
        }
      );
      return
    }

  }, [getSingleMds])



  return (
    <>
      <Card sx={{ mt: 2 }}>
        <Stack>
          <Stack
            sx={{ height: '90px' }}
            flexDirection="row"
          >
            <Stack
              sx={{ height: '100%', minWidth: '132px' }}
              flex={1.5}
            >
              <Stack
                sx={{
                  height: '40%',
                  padding: '6px 10px',
                  justifyContent: 'center',
                  borderRight: '1px solid #E5E7EB',
                  borderBottom: '1px solid #E5E7EB',
                  backgroundColor: '#F8F9FA',
                }}
              >
                <Box sx={{ fontSize: '12px', color: '#111927', fontWeight: '500' }}>
                  MDS Calendar Day
                </Box>
              </Stack>
              <Stack
                alignItems="center"
                justifyContent="center"
                sx={{
                  height: '40%',
                  padding: '8px 10px',
                  justifyContent: 'center',
                  borderRight: '1px solid #E5E7EB',
                  backgroundColor: '#F8F9FA',
                  alignItems: 'flex-start',
                }}
              >
                <Box
                  sx={{
                    fontSize: '12px',
                    color: '#111927',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  Disciplines & Dates
                </Box>
              </Stack>
              <Box
                sx={{
                  borderRight: '1px solid #E5E7EB',
                  borderBottom: '1px solid #E5E7EB',
                  backgroundColor: '#F8F9FA',
                  height: '20%',
                }}
              ></Box>
            </Stack>
            <Stack
              flexDirection="column"
              flex={8.5}
              sx={{ height: '100%' }}
            >
              <Stack
                flexDirection="row"
                sx={{
                  height: '40%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderBottom: '1px solid #F2F4F7',
                }}
              >
                {currentsDayList?.map((day: any, index: number) => {
                  return (
                    <React.Fragment key={index}>
                      <UncoveredDay
                        selectedPatient={selectedPatient}
                        day={day}
                        mdsAssessments={getMdsAssessmentRange?.[day?.dateFormat]}
                        uncoveredDayResponse={
                          therapyPlanning_2_0?.totalTimeSummary
                            ? Array.from(
                                therapyPlanning_2_0?.totalTimeSummary?.map((item: any) => ({
                                  uncovered: item.uncovered,
                                  date: item.date,
                                }))
                              )
                            : null
                        }
                        uncoveredCount={0}
                        index={index}
                        uncoveredDay={uncoveredDay}
                        setNavigateDate={setNavigateDate}
                      />
                    </React.Fragment>
                  );
                })}
              </Stack>
              <Stack
                flexDirection="row"
                sx={{
                  height: '40%',
                  display: 'flex',
                  borderBottom: '1px solid #F2F4F7',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {currentsDayList?.map((date: any, index: number) => (
                  <Box
                    sx={{
                      width: `calc(100% / 7)`,
                      height: '100%',
                      display: 'flex',
                      backgroundColor:
                        (uncoveredDay?.length === 9 && uncoveredDay[index]?.isUncoveredDay)
                          || getMdsAssessmentRange?.[date?.dateFormat]
                          ? '#F2F4F7'
                          : 'white',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    key={index}
                  >
                    <Box
                      sx={{
                        fontSize: '12px',
                        borderRight: '1px solid #F2F4F7',
                        color:
                          date?.dateFormat === moment().format('YYYY-MM-DD')
                            ? '#6366F1'
                            : date?.dateFormat === assessmentDate
                            ? 'white'
                            : '#111927',
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: date?.dateFormat === assessmentDate ? '#9d9d9d' : '',
                        width: '94%',
                        height: '75%',
                        borderRadius: '8px',
                        justifyContent: 'center',
                        fontWeight: '500',
                      }}
                    >
                      {date?.monthFormat}
                    </Box>
                  </Box>
                ))}
              </Stack>

              <Stack
                flexDirection="row"
                sx={{
                  height: '20%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderBottom: '1px solid #F2F4F7',
                }}
              >
                {Array.from({ length: 9 }).map((_: any, index: any) => {
                  return (
                    <Box
                      key={index}
                      sx={{
                        width: `calc(100% / 7)`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: '500',
                        borderRight: '1px solid #F2F4F7',
                        height: '100%',
                        color: '#B5BCC4',
                        fontSize: macbookScreen ? '8px' : '10px',
                      }}
                    >
                      Planned | Actual
                    </Box>
                  );
                })}
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Card>
      <TherapyCard_2_0
        therapyType="OT"
        therapyPlanningData_2_0={therapyPlaningNewResp?.otMap}
        uncoveredDay={uncoveredDay}
        actualDischargeDate={getDischargeDatesOfTherapyPlanning2_0?.actualOtDischargeDate}
        dischargeDate={getDischargeDatesOfTherapyPlanning2_0?.anticipatedOtDischargeDate}
        summaryData={therapyPlanningSummary?.therapyPlanningSummaryWithDate?.OT}
        frequencyStartDate={therapyPlanningSummary?.frequencyData?.freqAlertOT}
        dosOfTherapyCard={dateOfServiceResponse?.dateOfServiceOt ? dateOfServiceResponse?.dateOfServiceOt : null}
      />
      <TherapyCard_2_0
        therapyType="PT"
        therapyPlanningData_2_0={therapyPlaningNewResp?.ptMap}
        uncoveredDay={uncoveredDay}
        actualDischargeDate={getDischargeDatesOfTherapyPlanning2_0?.actualPtDischargeDate}
        dischargeDate={getDischargeDatesOfTherapyPlanning2_0?.anticipatedPtDischargeDate}
        summaryData={therapyPlanningSummary?.therapyPlanningSummaryWithDate?.PT}
        frequencyStartDate={therapyPlanningSummary?.frequencyData?.freqAlertPT}
        dosOfTherapyCard={dateOfServiceResponse?.dateOfServicePt ? dateOfServiceResponse?.dateOfServicePt : null}
      />
      <TherapyCard_2_0
        therapyType="SLP"
        therapyPlanningData_2_0={therapyPlaningNewResp?.slpMap}
        uncoveredDay={uncoveredDay}
        actualDischargeDate={getDischargeDatesOfTherapyPlanning2_0?.actualSlpDischargeDate}
        dischargeDate={getDischargeDatesOfTherapyPlanning2_0?.anticipatedSlpDischargeDate}
        summaryData={therapyPlanningSummary?.therapyPlanningSummaryWithDate?.SLP}
        frequencyStartDate={therapyPlanningSummary?.frequencyData?.freqAlertSLP}
        dosOfTherapyCard={dateOfServiceResponse?.dateOfServiceSlp ? dateOfServiceResponse?.dateOfServiceSlp : null}
      />
      <Card sx={{
        boxShadow: '0px 1px 10px 0px rgba(0, 0, 0, 0.15) !important',
        mb: 5, mt: 2
      }}>
        <SummaryCard_2_0
          totalMins={therapyPlanning_2_0?.totalTimeSummary}
          variation={therapyPlanning_2_0?.totalTimeSummary}
          currentsWeekList={currentsDayDataList}
          lookBackSum={getTherapyPlanningLookBack?.get7DayLookBackSumData}

        />
      </Card>
      {isSnackBarOpen && (
        <SimpleSnackbar
          message={message}
          isWarning={isWarning}
          isError={
            updateTherapyPlanningResponse?.response !== null &&
            updateTherapyPlanningResponse?.isTherapyPlanningUpdated === false
          }
        />
      )}
    </>
  );
};

export default WeekView_2_0;
